
import { Component, Vue } from 'vue-property-decorator';

@Component({
  metaInfo: {
    title: 'Лента'
  }
})
export default class FeedLayout extends Vue {}
